import { PageFallback } from "components/PageFallback";
import { lazy, Suspense } from "react";

let Share = lazy(() => import("./ShareLegal"));

export async function lazyShareLegalLoader() {
    const componentModule = await import("./ShareLegal");
    // This avoid flicker from React.lazy by using the component directly
    Share = componentModule.default as any;

    return null;
}

export function LazyShareLegal() {
    return (
        <Suspense fallback={<PageFallback />}>
            <Share />
        </Suspense>
    );
}
